import { lazy } from 'react';
//////////////////////////////////////////////////


export const lazyWithRetry = (importFn, useReactLazy) => {
  const key = 'lazy_retried';

  const fn = async () => {
    const retried = sessionStorage.getItem(key) === 'yes';

    try {
      return await importFn();
    } catch (err) {
      if (err?.name === 'ChunkLoadError' && !retried) {
        sessionStorage.setItem(key, 'yes');

        window.location.reload();
      }

      throw err;
    }
  };

  return useReactLazy ? lazy(fn) : fn;
};
